import { Router } from '@angular/router';
import { isValid } from 'date-fns';

import { epicDependencies } from '../../../store';
import {
    Population,
    SELECTED_ITEM_ALL_ID,
} from '../../../user/population-select';
import { DataDimension, DataSource, ReportType } from '../../backend';
import { currentBuilderState } from '../builder.state';
import { ParametersView } from '../model/parameters-view.model';

export function loadRouterQueryParams(): void {
    const router = epicDependencies.injector.get<Router>(Router);

    const state = currentBuilderState();
    const vp: ParametersView = {
        ...state.viewParams,
    };
    const qpm = router.parseUrl(router.url).queryParamMap;

    const startDate = !qpm.has('start_date')
        ? null
        : new Date(qpm.get('start_date'));
    const endDate = !qpm.has('end_date') ? null : new Date(qpm.get('end_date'));

    if (qpm.has('data_source')) {
        switch (qpm.get('data_source')) {
            case DataSource.Cache:
                vp.dataSource = DataSource.Cache;

                if (qpm.has('period_type')) {
                    vp.periodType = { id: Number(qpm.get('period_type')) };
                }

                if (isValid(endDate)) {
                    vp.cacheDate = {
                        periodType: vp.periodType?.id,
                        startDate: null,
                        endDate,
                        eventDate: null,
                    };
                }

                break;
            case DataSource.Raw:
                vp.dataSource = DataSource.Raw;

                if (isValid(startDate)) {
                    vp.rawStartDate = startDate;
                }

                if (isValid(endDate)) {
                    vp.rawEndDate = endDate;
                }

                break;
        }
    }

    if (qpm.has('report_type')) {
        switch (qpm.get('report_type')) {
            case ReportType.Role:
                vp.reportType = ReportType.Role;
                break;
            case ReportType.Team:
                vp.reportType = ReportType.Team;
                break;
            case ReportType.Individual:
                vp.reportType = ReportType.Individual;
                break;
        }
    }

    if (qpm.has('role')) {
        const roleId = Number(qpm.get('role'));
        vp.role = [
            {
                population: Population.Role,
                id: roleId,
                label: null,
            },
        ];
    }

    if (qpm.has('team')) {
        const teamUserId = Number(qpm.get('team'));
        vp.team = [
            {
                population: Population.User,
                id: teamUserId,
                label: null,
            },
        ];
    }

    if (qpm.has('individual')) {
        const individualUserId = Number(qpm.get('individual'));
        vp.individual = [
            {
                population: Population.User,
                id: individualUserId,
                label: null,
            },
        ];
    }

    if (qpm.has('site')) {
        let siteId = Number(qpm.get('site'));
        if (siteId === -1) {
            siteId = SELECTED_ITEM_ALL_ID;
        }
        vp.site = [
            {
                population: Population.Site,
                id: siteId,
                label: null,
            },
        ];
    }

    if (qpm.has('super_group')) {
        vp.dataDimension = DataDimension.SuperGroup;
        const superGroupId = Number(qpm.get('super_group'));
        vp.superGroup = [
            {
                population: Population.SuperGroup,
                id: superGroupId,
                label: null,
            },
        ];
    }

    if (qpm.has('queue')) {
        vp.dataDimension = DataDimension.Queue;
        let queueId = Number(qpm.get('queue'));
        if (queueId === -1) {
            queueId = SELECTED_ITEM_ALL_ID;
        }
        vp.queue = [
            {
                population: Population.Queue,
                id: queueId,
                label: null,
            },
        ];
    }

    if (qpm.has('metrics')) {
        vp.metrics = (qpm.get('metrics') ?? '').split(',').map((e) => {
            return {
                id: Number(e.trim()),
                fullName: null,
                shortName: null,
                initials: null,
            };
        });
    }

    state.viewParams = vp;
}
